//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
        lockchassis: [],
        searchRequest: null,
      },

      mutations: {
        updatelockchassis(state, list) {
          state.lockchassis= list;
        },
        updateSearchlockchassisRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },

      actions: {
        async lockchassis({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))

          
          if (requestToSend.billingD.startDate)
          {
              const date = moment(requestToSend.billingD.startDate)
                          .endOf('d')
                          .toDate();
              // console.log(date)
              // console.log(date.getMonth())
              // console.log(date.getDate())
              var month = (date.getMonth() + 1).toString()
              if (month.length === 1)
              {
                  month = '0' + month
              }
      
              var day = date.getDate().toString()
              if (day.length === 1)
              {
                  day = '0' + day
              }
              requestToSend.billingD.startDate = date.getFullYear() + '-' + month + '-' + day
          }
      
          if (requestToSend.billingD.endDate)
          {
              const date = moment(requestToSend.billingD.endDate)
                          .endOf('d')
                          .toDate();
      
                          var month = (date.getMonth() + 1).toString()
                          if (month.length == 1)
                          {
                              month = '0' + month
                          }
                  
                          var day = date.getDate().toString()
                          if (day.length == 1)
                          {
                              day = '0' + day
                          }
              requestToSend.billingD.endDate = date.getFullYear() + '-' + month + '-' + day
          }
          else
          {
            if (requestToSend.billingD.startDate != null)
            {
              const date = moment(requestToSend.billingD.startDate)
                          .endOf('d')
                          .toDate();
              // console.log(date)
              // console.log(date.getMonth())
              // console.log(date.getDate())
              var month = (date.getMonth() + 1).toString()
              if (month.length === 1)
              {
                  month = '0' + month
              }
      
              var day = date.getDate().toString()
              if (day.length === 1)
              {
                  day = '0' + day
              }
      
              requestToSend.billingD.endDate = date.getFullYear() + '-' + month + '-' + day
            }
              
          }

          console.log(requestToSend);

          // const validDate = requestToSend.validOn;
          // requestToSend.validOn = dateFormat.gstDateFormat(validDate);
            const st = performance.now();
            //const result = await api.post('/api/w/apar/chassislist', requestToSend);
            const result = await newAPIPost('/api/w/apar/chassislist', requestToSend);
            commit('updateSearchlockchassisRequest', fallbackRequest);
            // console.log(JSON.stringify(result));
            return commit('updatelockchassis', result);
            
        },

        async lockchassispartial({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))

          
          if (requestToSend.billingD.startDate)
          {
              const date = moment(requestToSend.billingD.startDate)
                          .endOf('d')
                          .toDate();
              // console.log(date)
              // console.log(date.getMonth())
              // console.log(date.getDate())
              var month = (date.getMonth() + 1).toString()
              if (month.length === 1)
              {
                  month = '0' + month
              }
      
              var day = date.getDate().toString()
              if (day.length === 1)
              {
                  day = '0' + day
              }
              requestToSend.billingD.startDate = date.getFullYear() + '-' + month + '-' + day
          }
      
          if (requestToSend.billingD.endDate)
          {
              const date = moment(requestToSend.billingD.endDate)
                          .endOf('d')
                          .toDate();
      
                          var month = (date.getMonth() + 1).toString()
                          if (month.length == 1)
                          {
                              month = '0' + month
                          }
                  
                          var day = date.getDate().toString()
                          if (day.length == 1)
                          {
                              day = '0' + day
                          }
              requestToSend.billingD.endDate = date.getFullYear() + '-' + month + '-' + day
          }
          else
          {
            if (requestToSend.billingD.startDate != null)
            {
              const date = moment(requestToSend.billingD.startDate)
                          .endOf('d')
                          .toDate();
              // console.log(date)
              // console.log(date.getMonth())
              // console.log(date.getDate())
              var month = (date.getMonth() + 1).toString()
              if (month.length === 1)
              {
                  month = '0' + month
              }
      
              var day = date.getDate().toString()
              if (day.length === 1)
              {
                  day = '0' + day
              }
      
              requestToSend.billingD.endDate = date.getFullYear() + '-' + month + '-' + day
            }
              
          }

          var pageseq = 0;
    
          console.log(requestToSend);

          // const validDate = requestToSend.validOn;
          // requestToSend.validOn = dateFormat.gstDateFormat(validDate);
            const st = performance.now();

            //run partial 
            var mainresult = [];
            var tempresult = [];
            var p_recleft = 1;
            var process = 5;
            var forcestop = 5;
            while (p_recleft > 0 || process == 0 || forcestop == 0)
            {
              requestToSend.sendSeq = pageseq.toString();
              //await api.post('/api/w/apar/chassislistpartial', requestToSend)
              await newAPIPost('/api/w/apar/chassislistpartial', requestToSend)
               .then((res) => {
                  if (res) {
                      tempresult = [];
                      tempresult = res.billingChassislists;
                      mainresult = [].concat(mainresult,tempresult);
                      p_recleft = res.recLeft;
                      console.log(`chassis rpt recleft: ${p_recleft} mainresult size: ${mainresult.length}`);
                      pageseq += 1;
                      if (p_recleft != null && p_recleft != '')
                         requestToSend.recLeft = parseInt(p_recleft.toString());
                      else {
                         requestToSend.recLeft = null;
                      }  
                    }                
                  process -= 1;
                });
              forcestop -= 1;  
            }
            commit('updateSearchlockchassisRequest', fallbackRequest);
            return commit('updatelockchassis', mainresult);
            //end run partial

            //run single search
            // const result = await api.post('/api/w/apar/chassislist', requestToSend);
            //commit('updateSearchlockchassisRequest', fallbackRequest);
            //// console.log(JSON.stringify(result));
            //return commit('updatelockchassis', result);
            //end run single search

         },
 

      },


      getters: {
        getlockchassis: state => state.lockchassis,
      },
}